// src/pages/DashboardPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
<center>      <h2>Dashboard</h2></center>

      <div className="card-grid">
        {/* Manage Bills card */}
        <div className="card" onClick={() => navigate('/bills')}>
          <h3>Manage Bills</h3>
          <p>Create / view / finalize bills</p>
        </div>

        {/* Add New Item card */}
        <div className="card" onClick={() => navigate('/items')}>
          <h3>Add New Item</h3>
          <p>Upload item name, price & image</p>
        </div>

        {/* Reports card (daily report as an example) */}
        <div className="card" onClick={() => navigate('/bills/report/daily')}>
          <h3>Daily Report</h3>
          <p>View today’s sales breakdown</p>
        </div>

        {/* Settings card */}
        <div className="card" onClick={() => navigate('/settings')}>
          <h3>Settings</h3>
          <p>Update Name, Address & Phone</p>
        </div>
      </div>
    </div>
  );
}
